// "I Map User Intent to Agent Skills Without an LLM" — Capability Inference short.
// Cold Compute / Neon kit. ~110s @ 30fps.
//
// HONESTY NOTE (drives the script): the PRIMARY mapping is pure keyword/
// deterministic (inferCapabilitiesFromIntent) — no LLM on the hot path. There
// IS a real LLM tie-breaker, but it only fires on EXACTLY medium-confidence
// intents that don't already match a canonical pattern, max_tokens=200, and it
// can only ADD capabilities, never override the matcher. The video leans into
// "why a keyword matcher beats an LLM call here" and names the guarded fallback.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
// Each duration ≈ round((lastCaption.fromSec + ~6) * 30) so the last caption
// never gets cut off and there's no dead air.
export const SCENE = {
  hook: { start: 0, duration: 210 }, //        0:00–0:07   one caption, the thesis
  problem: { start: 210, duration: 390 }, //   0:07–0:20   why NOT an LLM on the hot path
  intuition: { start: 600, duration: 390 }, // 0:20–0:33   the words already say it
  approach: { start: 990, duration: 390 }, //  0:33–0:46   pipeline: intent → rules → caps → confidence
  code: { start: 1380, duration: 580 }, //     0:46–1:05   the real KEYWORD_RULES + confidence buckets
  tiebreak: { start: 1960, duration: 400 }, // 1:05–1:18   the ONE guarded place an LLM runs (honesty)
  payoff: { start: 2360, duration: 400 }, //   1:18–1:32   ≥3 caps = high; zero LLM on the common path
  outro: { start: 2760, duration: 360 }, //    1:32–1:44   takeaway
} as const;

export const TOTAL_DURATION = 3120; // 104s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
